if (!customElements.get("wol-read-more")) {
  class WolReadMore extends HTMLElement {
    connectedCallback() {
      this.text = this.querySelector("._wall-of-love-card__text");
      this.btn = this.querySelector("._wall-of-love-card__read-more");
      if (!this.text || !this.btn) return;

      this.readMoreLabel = this.dataset.readMoreLabel || "Read more";
      this.showLessLabel = this.dataset.showLessLabel || "Show less";

      // The button is hidden by default; reveal it only when the clamp actually
      // truncates the text (adds ~2px tolerance for sub-pixel rounding).
      if (this.text.scrollHeight > this.text.clientHeight + 2) {
        this.btn.hidden = false;
      }
      this.btn.addEventListener("click", this.toggle.bind(this));
    }

    toggle() {
      const expanded = this.classList.toggle("_wall-of-love-card__text-wrapper--expanded");
      this.btn.textContent = expanded ? this.showLessLabel : this.readMoreLabel;
    }
  }
  customElements.define("wol-read-more", WolReadMore);
}
